 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }import { mergeAttributes} from '@tiptap/core'
import {Details, DetailsContent, DetailsSummary} from '@tiptap/extension-details'
import {TaskItem, TaskList} from '@tiptap/extension-list'
import Mention, {} from '@tiptap/extension-mention'
import {Table, TableCell, TableHeader, TableRow} from '@tiptap/extension-table'
import {Markdown} from '@tiptap/markdown'
import StarterKit from '@tiptap/starter-kit'
import {LoomExtension} from '../../components/promptResponse/loomExtension'
import {Database} from '../../tiptap/extensions/database/Database'
import {UniqueID} from '../../tiptap/extensions/docWithID/UniqueID'
import {ImageBlockBase} from '../../tiptap/extensions/imageBlock/ImageBlockBase'
import {MentionTaskTag} from '../../utils/MentionTaskTag'
import {ImageUploadBase} from './extensions/ImageUploadBase'
import {InsightsBlockBase} from './extensions/InsightsBlockBase'
import {PageLinkBlockBase} from './extensions/PageLinkBlockBase'
import {ResponseBlockBase} from './extensions/ResponseBlockBase'
import {TaskBlockBase} from './extensions/TaskBlockBase'
import {ThinkingBlockBase} from './extensions/ThinkingBlockBase'
export const mentionConfig = {
  renderText({node}) {
    return node.attrs.label
  },
  renderHTML({options, node}) {
    return ['span', options.HTMLAttributes, `${_nullishCoalesce(node.attrs.label, () => ( node.attrs.id))}`]
  }
}
export const serverTipTapExtensions = [
  StarterKit.extend({
    link: {
      parseHTML() {
        return [
          {
            tag: 'a[href]:not([data-type="button"]):not([href *= "javascript:" i])'
          }
        ]
      },

      renderHTML({HTMLAttributes}) {
        return [
          'a',
          mergeAttributes((this ).options.HTMLAttributes, HTMLAttributes, {class: 'link'}),
          0
        ]
      }
    }
  } ),
  Details.configure({
    persist: true
  }),
  DetailsSummary,
  DetailsContent,
  Table,
  TableRow,
  TableHeader,
  TableCell,
  TaskList,
  TaskItem.configure({
    nested: true
  }),
  ImageUploadBase,
  ImageBlockBase,
  LoomExtension,
  Mention.configure(mentionConfig),
  MentionTaskTag,
  InsightsBlockBase,
  UniqueID,
  PageLinkBlockBase,
  Database,
  TaskBlockBase,
  ThinkingBlockBase,
  ResponseBlockBase,
  Markdown
]
